// Generated by scripts/generate-public-surface.ts. Do not edit.

import type { CountryValidator } from "../../types";

import { createValidator } from "#stdnum-runtime";

const ssn: CountryValidator<"CH"> = createValidator(
  "ch.ssn",
  32,
);

export default ssn;
export const compact = ssn.compact;
export const format = ssn.format;
export const validate = ssn.validate;
export const generate = (): string =>
  ssn.generate?.() ??
  (() => {
    throw new Error(
      "Validator ch.ssn cannot generate values",
    );
  })();
